import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext'; // <-- MUDANÇA: Usa o contexto
import '../styles/Loader.css';

// <-- MUDANÇA: Recebe a prop 'requiredModule'
const ProtectedRoute = ({ children, requiredModule }) => {
  const { userData, loading } = useUser();

  if (loading) {
    return (
      <div className="loader">
        <div className="loader-text">Loading...</div>
        <div className="loader-bar"></div>
      </div>
    );
  }

  // Se não há dados do usuário (não está logado), redireciona para o login
  if (!userData) {
    return <Navigate to="/" />;
  }

  // <-- MUDANÇA: Verifica se a rota exige um módulo e se o usuário o possui
  if (requiredModule && !userData.modulosAssinados?.includes(requiredModule)) {
    // Se o usuário não tem o módulo, redireciona para o dashboard principal
    // (ou para uma página de "acesso negado", se preferir)
    return <Navigate to="/dashboard" />;
  }

  // Se passou em todas as verificações, renderiza a página solicitada
  return children;
};

export default ProtectedRoute;

